import React, {useState} from 'react';
import './App.scss';
import WealthCountries from './components/wealth-countries/wealth-countries';
import WealthCities from './components/wealth-cities/wealth-cities';
import AfricaCities from './components/africa-cities/africa-cities';
// import VsAfrica from './components/vs-africa/vs-africa';
import HPI from './components/hpi/hpi';
import HPP from './components/hpp/hpp';
import Openness from './components/openness/openness';
import Opportunity from './components/opportunity/opportunity';


// const radioBoxData = [
//   { value: 'wealth-countries', label: 'Wealthiest countries' },
//   { value: 'wealth-cities', label: 'Wealthiest cities' },
//   // { value: 'vs', label: 'Africa vs world' },
//   { value: 'expensive', label: 'Most expensive cities' },
//   { value: 'hpi', label: 'Top 20 HPI' },
//   { value: 'hpp', label: 'Top 20 HPP' },
//   { value: 'openness', label: 'Top 20 Openness' },
//   { value: 'opportunity', label: 'Opportunity Index' },

// ];

const App = () => {

  // const [radioboxSelected, setRadioboxSelected] = useState(radioBoxData[0].value);
  // const [menuTitle, setMenuTitle] = useState(radioBoxData[0].label);
  // const [menuOpen, setMenuOpen] = useState(false);

  
  // const handleRadioboxChange = (event) =>{
  //   setRadioboxSelected(event.target.value);
  //   setMenuOpen(false);

  //   let selectedRadioData = radioBoxData.filter((item) => item.value === event.target.value);
  //   // console.log(selectedRadioData);
  //   setMenuTitle(selectedRadioData[0].label);
  // }

  // const handleMenuOpen = () =>{
  //   setMenuOpen(!menuOpen);
  // }

  // const componentsSwitch = (value) =>{
  //   switch (value) {
  //     case "wealth-countries":
  //       return <WealthCountries />;
  //     case "wealth-cities":
  //       return <WealthCities />;
  //     // case "vs":
  //     //   return <VsAfrica />;
  //     case "expensive":
  //       return <AfricaCities />;
  //     case "hpi":
  //       return <HPI />;
  //     case "hpp":
  //       return <HPP />;
  //     case "openness":
  //       return <Openness />;      
  //     case "opportunity":
  //       return <Opportunity />;
  //     default:
  //       return <Opportunity />;
  //   }
  // }

//   {sortColumn !== 'wealthGrowth' ? 
//     <td rowSpan={2} className={`text-right ${styles.hiddenTableRow} ${styles.sortableColumn} ${sortColumn ? styles.selectedColumn : ''} ${styles.combinateRowCells} `}>
//       {formatNumberWithDot(item[sortColumn])}
//     </td>
//     : ''
//   }
  
//   </tr>
  
//   <tr className={`${styles.hiddenTableRow}`}>
//   <td className={`${styles.countryMobileDiv}`}
//       style={{  'borderRight': '1px solid #C1C5C8' }}>
//     <CountryFlag country={item.country} code={item.code} />
//   </td>
// </tr>


  return (
    <div className="App">
      <div className="appContainer">
          {/* <div className={`mobileMenuWrapper mb-md-5 ${menuOpen ? "menuOpen": ""}`}>
            <button className="mobileMenuToggle" onClick={handleMenuOpen}>
              <div className="mobileMenuTitleText">{menuTitle}</div>

              <div className='dropdownIcon'>
                
                <svg width="14px" height="6px" viewBox="0 0 14 6">
                    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                        <g transform="translate(-368.000000, -22.000000)" stroke="#405363">
                            <polyline points="381 22 375 28 369 22"></polyline>
                        </g>
                    </g>
                </svg>
              </div>
            </button>
            <div className="custom-radiobox-group" style={{'width': '100%', 'maxWidth': '740px'}}>
                  {radioBoxData.map((radioBox, index) => (
                    <label className="custom-radiobox" key={index}>
                      <input type="radio" value={radioBox.value} name="radio" checked={radioboxSelected === radioBox.value} onChange={handleRadioboxChange} /> 
                      <span className="label-text">{radioBox.label}</span>
                    </label>
                  ))}
            </div>
          </div>

          {componentsSwitch(radioboxSelected)} */}
        
      </div>
      
    </div>
  );
}

export default App;
